import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Attached directly to the <turbo-cable-stream-source> element rendered by
// turbo_stream_from. That element toggles its own "connected" attribute on/off
// as its ActionCable subscription connects/disconnects (see
// TurboCableStreamSourceElement#subscriptionConnected/subscriptionDisconnected
// in @hotwired/turbo-rails). A disconnect means any broadcasts sent while
// offline were missed — ActionCable's ConnectionMonitor reconnects the socket
// automatically, but never replays missed messages. On reconnect we force a
// Turbo page refresh so the DOM gets morphed back in sync with the server.
export default class extends Controller {
  connect() {
    this.wasDisconnected = false
    this.observer = new MutationObserver(this.handleConnectedChange.bind(this))
    this.observer.observe(this.element, { attributes: true, attributeFilter: ["connected"] })
  }

  disconnect() {
    this.observer.disconnect()
  }

  handleConnectedChange() {
    if (!this.element.hasAttribute("connected")) {
      this.wasDisconnected = true
    } else if (this.wasDisconnected) {
      this.wasDisconnected = false
      Turbo.session.refresh(document.baseURI)
    }
  }
}
